import { ENDPOINTS } from "../constants";
import { axios } from "../utils";
import defaultStatusChangeEventMock from "../mock/defaultStatusChangeEventMock.json"

export class StatusChangeEventApiCaller {

public static async getStatusChangeEventDatan(): Promise<any> {
    try {
      const url = `${ENDPOINTS.STATUSCHANGEEVENT.getStatusChangeEvent}`;
      // Make the API call.
      const response: any = await axios<any>({
        method: "GET",
        url: url
      });
      //Testing Use Response
       console.log("response",response,defaultStatusChangeEventMock)
      // Since no errors were found in the API
      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  public static async setStatusChangeEventOption(_statusChangeBenefitCombinationID: number): Promise<any> {
    try {
      const url = `${ENDPOINTS.STATUSCHANGEEVENT.changeOption}`;
      // Make the API call.
      const response: any = await axios<any>({
        method: "PUT",
        url,
        data:{
          statusChangeBenefitCombinationID:_statusChangeBenefitCombinationID
        } 
      });
      // Since no errors were found in the API
      // response, return the response data.
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public static async saveStatusChangeEventOption(_statusChangeBenefitCombinationID: number,isConfirmed:boolean): Promise<any> {
    try {
      const url = `${ENDPOINTS.STATUSCHANGEEVENT.save}`;
      // Make the API call.
      const response: any = await axios<any>({
        method: "POST",
        url,
        data:{
          statusChangeBenefitCombinationID:_statusChangeBenefitCombinationID,
          isConfirmed:isConfirmed
        } 
      });
      // Since no errors were found in the API
      // response, return the response data.
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
}